import maskers from './maskers';

const { matchAndInsert, removeSpaces } = maskers;

export default {
  AT: [
    removeSpaces,
    value => matchAndInsert(value, { match: /(\+43)(\d*)/, insert: ' ' })
  ],
  CZ: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+420)(\d{3})(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  AU: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+61)(\d{3})(\d{3})(\d{3})/,
        insert: ' '
      })
  ],
  AO: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+244)(\d{3})(\d{3})(\d{*})/,
        insert: ' '
      })
  ],
  BR: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+55)(\d{2})(9\d{4})(\d*)/,
        insert: ' '
      })
  ],
  CH: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+41)(\d{2})(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  CV: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+238)(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  DK: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+45)(\d{2})(\d{2})(\d{2})(\d*)/,
        insert: ' '
      })
  ],
  FO: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+298)(\d{2})(\d{2})(\d{2})/,
        insert: ' '
      })
  ],
  FR: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+33)(\d{1})(\d{2})(\d{2})(\d{2})(\d*)/,
        insert: ' '
      })
  ],
  GB: [
    removeSpaces,
    value =>
      matchAndInsert(value, { match: /(\+44)(\d{4})(\d{3})(\d*)/, insert: ' ' })
  ],
  GL: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+299)(\d{2})(\d{2})(\d{2})/,
        insert: ' '
      })
  ],
  GW: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+245)(\d{2})(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  HR: [removeSpaces],
  HU: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+36)(\d{2})(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  IE: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+353)(\d{2})(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  IN: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+91)(\d{2})(\d{4})(\d*)/,
        insert: ' '
      })
  ],
  JO: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+962)(\d)(\d{4})(\d*)/,
        insert: ' '
      })
  ],
  KW: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+965)(\d*)/,
        insert: ' '
      })
  ],
  KR: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+82)(\d{2})(\d{4})(\d*)/,
        insert: ' '
      })
  ],
  MA: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+212)(\d)(\d{2})(\d{2})(\d{2})(\d*)/,
        insert: ' '
      })
  ],
  MX: [
    removeSpaces,
    value =>
      matchAndInsert(value, { match: /(\+52)(\d{3})(\d{3})(\d*)/, insert: '-' })
  ],
  MZ: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match:
          value.length > 12 ? /(\+258)(\d{3})(\d*)/ : /(\+258)(\d{2})(\d*)/,
        insert: ' '
      })
  ],
  NL: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+31)(\d{1})(\d*)/,
        insert: ' '
      })
  ],
  NO: [
    removeSpaces,
    value =>
      matchAndInsert(value, { match: /(\+47)(\d{3})(\d{2})(\d*)/, insert: ' ' })
  ],
  PH: [
    removeSpaces,
    value =>
      matchAndInsert(value, { match: /(\+63\d)(\d{3})(\d*)/, insert: ' ' })
  ],
  PL: [
    removeSpaces,
    value =>
      matchAndInsert(value, { match: /(\+48)(\d{3})(\d{3})(\d*)/, insert: ' ' })
  ],
  RU: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+7)(\d{3})(\d{3})(\d{2})(\d*)/,
        insert: ' '
      })
  ],
  'RU/KZ': [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+7)(\d{3})(\d{3})(\d{2})(\d*)/,
        insert: ' '
      })
  ],
  SAF: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+27)(\d{2})(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  SI: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+386)(\d{2})(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  SK: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+421)(\d{3})(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  ST: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+239)(\d{3})(\d*)/,
        insert: ' '
      })
  ],
  UA: [
    removeSpaces,
    value =>
      matchAndInsert(value, {
        match: /(\+380)(\d{2})(\d{3})(\d{2})(\d*)/,
        insert: ' '
      })
  ],
  'USA/CA': [
    removeSpaces,
    value =>
      matchAndInsert(value, { match: /(\+1)(\d{3})(\d{3})(\d*)/, insert: '-' })
  ]
};

// There can be one or more masking rules for each key defined in
// "defaultCountryCodeMap" in countryCodes.js
